import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { trackPageView } from '../utils/analytics';

// Envia um pageview a cada troca de rota. Sem isso o GA registraria apenas a
// primeira página aberta, já que o React Router navega sem recarregar o
// documento — e era justamente o dado por post que ficaria de fora.
export function usePageTracking() {
  const { pathname } = useLocation();

  useEffect(() => {
    trackPageView(pathname);
  }, [pathname]);
}
